var ClientType = /* @__PURE__ */ ((ClientType2) => {
  ClientType2["H5"] = "h5";
  ClientType2["WXAPP"] = "wxapp";
  ClientType2["ALIPAYAPP"] = "alipayapp";
  return ClientType2;
})(ClientType || {});
var RuntimeEnv = /* @__PURE__ */ ((RuntimeEnv2) => {
  RuntimeEnv2["WECHAT_BROWSER"] = "wechat_browser";
  RuntimeEnv2["ALIPAY_BROWSER"] = "alipay_browser";
  RuntimeEnv2["NORMAL"] = "normal";
  RuntimeEnv2["PC"] = "pc";
  return RuntimeEnv2;
})(RuntimeEnv || {});
var PayChannel = /* @__PURE__ */ ((PayChannel2) => {
  PayChannel2["WXPAY_MP"] = "wxpay_mp";
  PayChannel2["WXPAY_JSAPI"] = "wxpay_jsapi";
  PayChannel2["WXPAY_H5"] = "wxpay_h5";
  PayChannel2["WXPAY_NATIVE"] = "wxpay_native";
  PayChannel2["ALIPAY_APP"] = "alipay_app";
  PayChannel2["ALIPAY_WAP"] = "alipay_wap";
  return PayChannel2;
})(PayChannel || {});
const PHASE1_CHANNELS = [
  "wxpay_mp" /* WXPAY_MP */,
  "alipay_app" /* ALIPAY_APP */,
  "alipay_wap" /* ALIPAY_WAP */
];
const PHASE2_CHANNELS = ["wxpay_jsapi" /* WXPAY_JSAPI */];
const ORDER_NO_PREFIX = {
  ["wxpay_mp" /* WXPAY_MP */]: "WXM",
  ["wxpay_jsapi" /* WXPAY_JSAPI */]: "WXJ",
  ["wxpay_h5" /* WXPAY_H5 */]: "WXH",
  ["wxpay_native" /* WXPAY_NATIVE */]: "WXN",
  ["alipay_app" /* ALIPAY_APP */]: "ALA",
  ["alipay_wap" /* ALIPAY_WAP */]: "ALW"
};
const PAY_CHANNEL_LABEL = {
  ["wxpay_mp" /* WXPAY_MP */]: "\u5FAE\u4FE1\u652F\u4ED8",
  ["wxpay_jsapi" /* WXPAY_JSAPI */]: "\u5FAE\u4FE1\u652F\u4ED8",
  ["wxpay_h5" /* WXPAY_H5 */]: "\u5FAE\u4FE1\u652F\u4ED8",
  ["wxpay_native" /* WXPAY_NATIVE */]: "\u5FAE\u4FE1\u626B\u7801\u652F\u4ED8",
  ["alipay_app" /* ALIPAY_APP */]: "\u652F\u4ED8\u5B9D",
  ["alipay_wap" /* ALIPAY_WAP */]: "\u652F\u4ED8\u5B9D"
};
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2[PaymentStatus2["PENDING"] = 0] = "PENDING";
  PaymentStatus2[PaymentStatus2["SUCCESS"] = 1] = "SUCCESS";
  PaymentStatus2[PaymentStatus2["FAILED"] = 2] = "FAILED";
  PaymentStatus2[PaymentStatus2["CLOSED"] = 3] = "CLOSED";
  return PaymentStatus2;
})(PaymentStatus || {});
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2[OrderStatus2["UNPAID"] = 0] = "UNPAID";
  OrderStatus2[OrderStatus2["UNSHIPPED"] = 1] = "UNSHIPPED";
  OrderStatus2[OrderStatus2["SHIPPED"] = 2] = "SHIPPED";
  OrderStatus2[OrderStatus2["FINISHED"] = 3] = "FINISHED";
  OrderStatus2[OrderStatus2["CLOSED"] = 4] = "CLOSED";
  return OrderStatus2;
})(OrderStatus || {});
const ORDER_STATUS_TEXT = {
  [0 /* UNPAID */]: "\u5F85\u4ED8\u6B3E",
  [1 /* UNSHIPPED */]: "\u5F85\u53D1\u8D27",
  [2 /* SHIPPED */]: "\u5F85\u6536\u8D27",
  [3 /* FINISHED */]: "\u5DF2\u5B8C\u6210",
  [4 /* CLOSED */]: "\u5DF2\u5173\u95ED"
};
var PayStatus = /* @__PURE__ */ ((PayStatus2) => {
  PayStatus2[PayStatus2["UNPAID"] = 0] = "UNPAID";
  PayStatus2[PayStatus2["PAID"] = 1] = "PAID";
  PayStatus2[PayStatus2["REFUNDED"] = 2] = "REFUNDED";
  PayStatus2[PayStatus2["PARTIAL_REFUNDED"] = 3] = "PARTIAL_REFUNDED";
  return PayStatus2;
})(PayStatus || {});
const PAY_STATUS_TEXT = {
  [0 /* UNPAID */]: "\u672A\u652F\u4ED8",
  [1 /* PAID */]: "\u5DF2\u652F\u4ED8",
  [2 /* REFUNDED */]: "\u5DF2\u9000\u6B3E",
  [3 /* PARTIAL_REFUNDED */]: "\u90E8\u5206\u9000\u6B3E"
};
var OrderListTab = /* @__PURE__ */ ((OrderListTab2) => {
  OrderListTab2["ALL"] = "all";
  OrderListTab2["UNPAID"] = "unpaid";
  OrderListTab2["UNSHIPPED"] = "unship";
  OrderListTab2["SHIPPED"] = "shipped";
  OrderListTab2["FINISHED"] = "finished";
  OrderListTab2["REFUND"] = "refund";
  return OrderListTab2;
})(OrderListTab || {});
var OrderAction = /* @__PURE__ */ ((OrderAction2) => {
  OrderAction2["CANCEL"] = "cancel";
  OrderAction2["PAY"] = "pay";
  OrderAction2["CONTACT"] = "contact";
  OrderAction2["CONFIRM"] = "confirm";
  OrderAction2["VIEW_EXPRESS"] = "view_express";
  OrderAction2["REFUND_APPLY"] = "refund_apply";
  OrderAction2["REFUND_PROGRESS"] = "refund_progress";
  OrderAction2["COMMENT"] = "comment";
  OrderAction2["BUY_AGAIN"] = "buy_again";
  return OrderAction2;
})(OrderAction || {});
const ORDER_ACTION_TEXT = {
  ["cancel" /* CANCEL */]: "\u53D6\u6D88\u8BA2\u5355",
  ["pay" /* PAY */]: "\u53BB\u652F\u4ED8",
  ["contact" /* CONTACT */]: "\u8054\u7CFB\u5BA2\u670D",
  ["confirm" /* CONFIRM */]: "\u786E\u8BA4\u6536\u8D27",
  ["view_express" /* VIEW_EXPRESS */]: "\u67E5\u770B\u7269\u6D41",
  ["refund_apply" /* REFUND_APPLY */]: "\u7533\u8BF7\u552E\u540E",
  ["refund_progress" /* REFUND_PROGRESS */]: "\u552E\u540E\u8FDB\u5EA6",
  ["comment" /* COMMENT */]: "\u8BC4\u4EF7",
  ["buy_again" /* BUY_AGAIN */]: "\u518D\u6B21\u8D2D\u4E70"
};
const RefundAdminFlag = {
  /** 未标记 */
  NONE: 0,
  /** 红：紧急 */
  URGENT: 1,
  /** 黄：待跟进 */
  FOLLOW_UP: 2,
  /** 蓝：已联系客户 */
  CONTACTED: 3,
  /** 绿：已处理 */
  HANDLED: 4
};
const REFUND_ADMIN_FLAG_TEXT = {
  [RefundAdminFlag.NONE]: "\u672A\u6807\u8BB0",
  [RefundAdminFlag.URGENT]: "\u7D27\u6025",
  [RefundAdminFlag.FOLLOW_UP]: "\u5F85\u8DDF\u8FDB",
  [RefundAdminFlag.CONTACTED]: "\u5DF2\u8054\u7CFB",
  [RefundAdminFlag.HANDLED]: "\u5DF2\u5904\u7406"
};
const REFUND_TYPE_TEXT_ADMIN = {
  1: "\u4EC5\u9000\u6B3E",
  2: "\u9000\u8D27\u9000\u6B3E",
  3: "\u6362\u8D27"
};
var RefundType = /* @__PURE__ */ ((RefundType2) => {
  RefundType2[RefundType2["REFUND_ONLY"] = 1] = "REFUND_ONLY";
  RefundType2[RefundType2["RETURN_REFUND"] = 2] = "RETURN_REFUND";
  RefundType2[RefundType2["EXCHANGE"] = 3] = "EXCHANGE";
  return RefundType2;
})(RefundType || {});
const REFUND_TYPE_TEXT = {
  [1 /* REFUND_ONLY */]: "\u4EC5\u9000\u6B3E",
  [2 /* RETURN_REFUND */]: "\u9000\u8D27\u9000\u6B3E",
  [3 /* EXCHANGE */]: "\u6362\u8D27"
};
function isNoMoneyRefundType(type) {
  return type === 3 /* EXCHANGE */;
}
var RefundStatus = /* @__PURE__ */ ((RefundStatus2) => {
  RefundStatus2[RefundStatus2["PROCESSING"] = 0] = "PROCESSING";
  RefundStatus2[RefundStatus2["SUCCESS"] = 1] = "SUCCESS";
  RefundStatus2[RefundStatus2["FAILED"] = 2] = "FAILED";
  RefundStatus2[RefundStatus2["REJECTED"] = 3] = "REJECTED";
  return RefundStatus2;
})(RefundStatus || {});
const REFUND_STATUS_TEXT = {
  [0 /* PROCESSING */]: "\u9000\u6B3E\u5904\u7406\u4E2D",
  [1 /* SUCCESS */]: "\u5DF2\u9000\u6B3E",
  [2 /* FAILED */]: "\u9000\u6B3E\u5931\u8D25",
  [3 /* REJECTED */]: "\u5DF2\u9A73\u56DE"
};
function refundStatusText(type, status) {
  if (type === 3 /* EXCHANGE */) {
    const map = {
      [0 /* PROCESSING */]: "\u6362\u8D27\u5904\u7406\u4E2D",
      [1 /* SUCCESS */]: "\u6362\u8D27\u5DF2\u53D1\u51FA",
      [2 /* FAILED */]: "\u6362\u8D27\u5931\u8D25",
      [3 /* REJECTED */]: "\u6362\u8D27\u5DF2\u9A73\u56DE"
    };
    return map[status] ?? String(status);
  }
  return REFUND_STATUS_TEXT[status] ?? String(status);
}
var OrderItemRefundStatus = /* @__PURE__ */ ((OrderItemRefundStatus2) => {
  OrderItemRefundStatus2[OrderItemRefundStatus2["NONE"] = 0] = "NONE";
  OrderItemRefundStatus2[OrderItemRefundStatus2["PROCESSING"] = 1] = "PROCESSING";
  OrderItemRefundStatus2[OrderItemRefundStatus2["REFUNDED"] = 2] = "REFUNDED";
  OrderItemRefundStatus2[OrderItemRefundStatus2["PARTIAL"] = 3] = "PARTIAL";
  OrderItemRefundStatus2[OrderItemRefundStatus2["EXCHANGED"] = 4] = "EXCHANGED";
  return OrderItemRefundStatus2;
})(OrderItemRefundStatus || {});
const ORDER_ITEM_REFUND_STATUS_TEXT = {
  [0 /* NONE */]: "\u65E0\u552E\u540E",
  [1 /* PROCESSING */]: "\u552E\u540E\u5904\u7406\u4E2D",
  [2 /* REFUNDED */]: "\u5DF2\u9000\u6B3E",
  [3 /* PARTIAL */]: "\u90E8\u5206\u9000\u6B3E",
  [4 /* EXCHANGED */]: "\u5DF2\u6362\u8D27"
};
var RefundReason = /* @__PURE__ */ ((RefundReason2) => {
  RefundReason2["NO_LONGER_WANT"] = "no_longer_want";
  RefundReason2["QUALITY_ISSUE"] = "quality_issue";
  RefundReason2["WRONG_ITEM"] = "wrong_item";
  RefundReason2["MISSING_ITEM"] = "missing_item";
  RefundReason2["NOT_AS_DESCRIBED"] = "not_as_described";
  RefundReason2["OTHER"] = "other";
  return RefundReason2;
})(RefundReason || {});
const REFUND_REASON_TEXT = {
  ["no_longer_want" /* NO_LONGER_WANT */]: "\u4E0D\u60F3\u8981\u4E86",
  ["quality_issue" /* QUALITY_ISSUE */]: "\u5546\u54C1\u8D28\u91CF\u95EE\u9898",
  ["wrong_item" /* WRONG_ITEM */]: "\u53D1\u9519\u8D27",
  ["missing_item" /* MISSING_ITEM */]: "\u5C11\u4EF6/\u6F0F\u53D1",
  ["not_as_described" /* NOT_AS_DESCRIBED */]: "\u4E0E\u63CF\u8FF0\u4E0D\u7B26",
  ["other" /* OTHER */]: "\u5176\u4ED6"
};
var CallbackHandleResult = /* @__PURE__ */ ((CallbackHandleResult2) => {
  CallbackHandleResult2[CallbackHandleResult2["NOT_HANDLED"] = 0] = "NOT_HANDLED";
  CallbackHandleResult2[CallbackHandleResult2["SUCCESS"] = 1] = "SUCCESS";
  CallbackHandleResult2[CallbackHandleResult2["IDEMPOTENT_SKIP"] = 2] = "IDEMPOTENT_SKIP";
  CallbackHandleResult2[CallbackHandleResult2["FAILED"] = 3] = "FAILED";
  return CallbackHandleResult2;
})(CallbackHandleResult || {});
var CallbackEventType = /* @__PURE__ */ ((CallbackEventType2) => {
  CallbackEventType2["PAY_SUCCESS"] = "pay_success";
  CallbackEventType2["REFUND_SUCCESS"] = "refund_success";
  CallbackEventType2["UNKNOWN"] = "unknown";
  return CallbackEventType2;
})(CallbackEventType || {});
var CouponType = /* @__PURE__ */ ((CouponType2) => {
  CouponType2[CouponType2["FULL_REDUCE"] = 1] = "FULL_REDUCE";
  CouponType2[CouponType2["DISCOUNT"] = 2] = "DISCOUNT";
  CouponType2[CouponType2["NO_THRESHOLD"] = 3] = "NO_THRESHOLD";
  return CouponType2;
})(CouponType || {});
var CouponScopeType = /* @__PURE__ */ ((CouponScopeType2) => {
  CouponScopeType2[CouponScopeType2["ALL"] = 1] = "ALL";
  CouponScopeType2[CouponScopeType2["CATEGORY"] = 2] = "CATEGORY";
  CouponScopeType2[CouponScopeType2["PRODUCT"] = 3] = "PRODUCT";
  return CouponScopeType2;
})(CouponScopeType || {});
var UserCouponStatus = /* @__PURE__ */ ((UserCouponStatus2) => {
  UserCouponStatus2[UserCouponStatus2["UNUSED"] = 0] = "UNUSED";
  UserCouponStatus2[UserCouponStatus2["USED"] = 1] = "USED";
  UserCouponStatus2[UserCouponStatus2["EXPIRED"] = 2] = "EXPIRED";
  UserCouponStatus2[UserCouponStatus2["DISABLED"] = 3] = "DISABLED";
  return UserCouponStatus2;
})(UserCouponStatus || {});
var CouponValidType = /* @__PURE__ */ ((CouponValidType2) => {
  CouponValidType2[CouponValidType2["FIXED"] = 1] = "FIXED";
  CouponValidType2[CouponValidType2["DAYS_AFTER_RECEIVE"] = 2] = "DAYS_AFTER_RECEIVE";
  return CouponValidType2;
})(CouponValidType || {});
var CouponUnusableReason = /* @__PURE__ */ ((CouponUnusableReason2) => {
  CouponUnusableReason2["NOT_STARTED"] = "not_started";
  CouponUnusableReason2["EXPIRED"] = "expired";
  CouponUnusableReason2["BELOW_THRESHOLD"] = "below_threshold";
  CouponUnusableReason2["SCOPE_MISMATCH"] = "scope_mismatch";
  CouponUnusableReason2["ALREADY_USED"] = "already_used";
  return CouponUnusableReason2;
})(CouponUnusableReason || {});
const COUPON_UNUSABLE_TEXT = {
  ["not_started" /* NOT_STARTED */]: "\u672A\u5230\u4F7F\u7528\u65F6\u95F4",
  ["expired" /* EXPIRED */]: "\u5DF2\u8FC7\u671F",
  ["below_threshold" /* BELOW_THRESHOLD */]: "\u8BA2\u5355\u91D1\u989D\u672A\u8FBE\u95E8\u69DB",
  ["scope_mismatch" /* SCOPE_MISMATCH */]: "\u4E0D\u9002\u7528\u4E8E\u672C\u5355\u5546\u54C1",
  ["already_used" /* ALREADY_USED */]: "\u5DF2\u4F7F\u7528"
};
var PointsSource = /* @__PURE__ */ ((PointsSource2) => {
  PointsSource2["ORDER"] = "order";
  PointsSource2["SIGN"] = "sign";
  PointsSource2["REFUND"] = "refund";
  PointsSource2["ADMIN"] = "admin";
  PointsSource2["EXPIRE"] = "expire";
  PointsSource2["PROFILE"] = "profile";
  PointsSource2["COMMENT"] = "comment";
  return PointsSource2;
})(PointsSource || {});
const POINTS_SOURCE_TEXT = {
  ["order" /* ORDER */]: "\u8D2D\u7269\u8FD4\u79EF\u5206",
  ["sign" /* SIGN */]: "\u6BCF\u65E5\u7B7E\u5230",
  ["refund" /* REFUND */]: "\u9000\u6B3E\u6263\u56DE",
  ["admin" /* ADMIN */]: "\u540E\u53F0\u8C03\u6574",
  ["expire" /* EXPIRE */]: "\u79EF\u5206\u8FC7\u671F",
  ["profile" /* PROFILE */]: "\u5B8C\u5584\u8D44\u6599",
  ["comment" /* COMMENT */]: "\u8BC4\u4EF7\u5956\u52B1"
};
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2[UserStatus2["NORMAL"] = 1] = "NORMAL";
  UserStatus2[UserStatus2["BLOCKED"] = 2] = "BLOCKED";
  return UserStatus2;
})(UserStatus || {});
var FreightType = /* @__PURE__ */ ((FreightType2) => {
  FreightType2[FreightType2["FREE_ALL"] = 1] = "FREE_ALL";
  FreightType2[FreightType2["FREE_OVER_AMOUNT"] = 2] = "FREE_OVER_AMOUNT";
  FreightType2[FreightType2["FLAT"] = 3] = "FLAT";
  return FreightType2;
})(FreightType || {});
var ProductStatus = /* @__PURE__ */ ((ProductStatus2) => {
  ProductStatus2[ProductStatus2["OFF_SHELF"] = 0] = "OFF_SHELF";
  ProductStatus2[ProductStatus2["ON_SHELF"] = 1] = "ON_SHELF";
  return ProductStatus2;
})(ProductStatus || {});
var CartItemInvalidReason = /* @__PURE__ */ ((CartItemInvalidReason2) => {
  CartItemInvalidReason2["OFF_SHELF"] = "off_shelf";
  CartItemInvalidReason2["SOLD_OUT"] = "sold_out";
  return CartItemInvalidReason2;
})(CartItemInvalidReason || {});
const CART_INVALID_TEXT = {
  ["off_shelf" /* OFF_SHELF */]: "\u5546\u54C1\u5DF2\u4E0B\u67B6",
  ["sold_out" /* SOLD_OUT */]: "\u5546\u54C1\u5DF2\u552E\u7F44"
};
var ReconcileDiffType = /* @__PURE__ */ ((ReconcileDiffType2) => {
  ReconcileDiffType2[ReconcileDiffType2["PLATFORM_ONLY"] = 1] = "PLATFORM_ONLY";
  ReconcileDiffType2[ReconcileDiffType2["SYSTEM_ONLY"] = 2] = "SYSTEM_ONLY";
  ReconcileDiffType2[ReconcileDiffType2["AMOUNT_MISMATCH"] = 3] = "AMOUNT_MISMATCH";
  return ReconcileDiffType2;
})(ReconcileDiffType || {});
const RECONCILE_DIFF_TEXT = {
  [1 /* PLATFORM_ONLY */]: "\u5E73\u53F0\u6709 \xB7 \u7CFB\u7EDF\u65E0",
  [2 /* SYSTEM_ONLY */]: "\u7CFB\u7EDF\u6709 \xB7 \u5E73\u53F0\u65E0",
  [3 /* AMOUNT_MISMATCH */]: "\u91D1\u989D\u4E0D\u4E00\u81F4"
};
var ReconcileHandleStatus = /* @__PURE__ */ ((ReconcileHandleStatus2) => {
  ReconcileHandleStatus2[ReconcileHandleStatus2["PENDING"] = 0] = "PENDING";
  ReconcileHandleStatus2[ReconcileHandleStatus2["HANDLED"] = 1] = "HANDLED";
  ReconcileHandleStatus2[ReconcileHandleStatus2["IGNORED"] = 2] = "IGNORED";
  return ReconcileHandleStatus2;
})(ReconcileHandleStatus || {});
var AdminRoleCode = /* @__PURE__ */ ((AdminRoleCode2) => {
  AdminRoleCode2["SUPER"] = "super";
  AdminRoleCode2["OPERATOR"] = "operator";
  AdminRoleCode2["SERVICE"] = "service";
  AdminRoleCode2["FINANCE"] = "finance";
  return AdminRoleCode2;
})(AdminRoleCode || {});
const ADMIN_ROLE_TEXT = {
  ["super" /* SUPER */]: "\u8D85\u7EA7\u7BA1\u7406\u5458",
  ["operator" /* OPERATOR */]: "\u8FD0\u8425",
  ["service" /* SERVICE */]: "\u5BA2\u670D",
  ["finance" /* FINANCE */]: "\u8D22\u52A1"
};
var WaybillStatus = /* @__PURE__ */ ((WaybillStatus2) => {
  WaybillStatus2[WaybillStatus2["CREATED"] = 0] = "CREATED";
  WaybillStatus2[WaybillStatus2["PRINTED"] = 1] = "PRINTED";
  WaybillStatus2[WaybillStatus2["CANCELLED"] = 2] = "CANCELLED";
  WaybillStatus2[WaybillStatus2["FAILED"] = 3] = "FAILED";
  return WaybillStatus2;
})(WaybillStatus || {});
const WAYBILL_STATUS_TEXT = {
  [0 /* CREATED */]: "\u5DF2\u53D6\u53F7 \xB7 \u5F85\u6253\u5370",
  [1 /* PRINTED */]: "\u5DF2\u6253\u5370",
  [2 /* CANCELLED */]: "\u5DF2\u4F5C\u5E9F",
  [3 /* FAILED */]: "\u53D6\u53F7\u5931\u8D25"
};
var WaybillPrintType = /* @__PURE__ */ ((WaybillPrintType2) => {
  WaybillPrintType2["NON"] = "NON";
  WaybillPrintType2["IMAGE"] = "IMAGE";
  WaybillPrintType2["HTML"] = "HTML";
  WaybillPrintType2["CLOUD"] = "CLOUD";
  WaybillPrintType2["ORDERFIRST"] = "ORDERFIRST";
  return WaybillPrintType2;
})(WaybillPrintType || {});
const KUAIDI100_COM = {
  SHUNFENG: "shunfeng"
};
const KUAIDI100_COM_TEXT = {
  [KUAIDI100_COM.SHUNFENG]: "\u987A\u4E30\u901F\u8FD0"
};
export {
  ADMIN_ROLE_TEXT,
  AdminRoleCode,
  CART_INVALID_TEXT,
  COUPON_UNUSABLE_TEXT,
  CallbackEventType,
  CallbackHandleResult,
  CartItemInvalidReason,
  ClientType,
  CouponScopeType,
  CouponType,
  CouponUnusableReason,
  CouponValidType,
  FreightType,
  KUAIDI100_COM,
  KUAIDI100_COM_TEXT,
  ORDER_ACTION_TEXT,
  ORDER_ITEM_REFUND_STATUS_TEXT,
  ORDER_NO_PREFIX,
  ORDER_STATUS_TEXT,
  OrderAction,
  OrderItemRefundStatus,
  OrderListTab,
  OrderStatus,
  PAY_CHANNEL_LABEL,
  PAY_STATUS_TEXT,
  PHASE1_CHANNELS,
  PHASE2_CHANNELS,
  POINTS_SOURCE_TEXT,
  PayChannel,
  PayStatus,
  PaymentStatus,
  PointsSource,
  ProductStatus,
  RECONCILE_DIFF_TEXT,
  REFUND_ADMIN_FLAG_TEXT,
  REFUND_REASON_TEXT,
  REFUND_STATUS_TEXT,
  REFUND_TYPE_TEXT,
  REFUND_TYPE_TEXT_ADMIN,
  ReconcileDiffType,
  ReconcileHandleStatus,
  RefundAdminFlag,
  RefundReason,
  RefundStatus,
  RefundType,
  RuntimeEnv,
  UserCouponStatus,
  UserStatus,
  WAYBILL_STATUS_TEXT,
  WaybillPrintType,
  WaybillStatus,
  isNoMoneyRefundType,
  refundStatusText
};
